var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{staticClass:"sub-tabs",attrs:{"value":_vm.activeTab,"type":"is-toggle"},on:{"input":_vm.changeTab}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }